import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { formatCurrency } from '@/lib/utils/format';
import { CostWaterfallStep } from '../types/quote.types';
import { ArrowDown } from 'lucide-react';

interface CostWaterfallProps {
  steps: CostWaterfallStep[];
  currencySymbol: string;
}

export function CostWaterfall({ steps, currencySymbol }: CostWaterfallProps) {
  if (steps.length === 0) {
    return null;
  }

  let cumulative = 0;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Cascada de Costos</CardTitle>
        <CardDescription>Desglose del cálculo de precio</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {steps.map((step, index) => {
            if (!step.isCumulative) {
              cumulative += step.amount;
            }

            const displayAmount = step.isCumulative ? cumulative : step.amount;

            return (
              <div key={index}>
                <div className="flex items-center justify-between p-3 rounded-lg bg-accent/50 hover:bg-accent transition-colors">
                  <div className="flex items-center gap-3">
                    {step.isCumulative ? (
                      <div className="w-3 h-3 rounded-full bg-primary" />
                    ) : (
                      <div className={`w-3 h-3 rounded-full ${step.color || 'bg-muted'}`} />
                    )}
                    <div>
                      <p className={`font-medium ${step.isCumulative ? 'text-lg' : ''}`}>
                        {step.label}
                      </p>
                      {step.percentage && (
                        <p className="text-xs text-muted-foreground">
                          {step.percentage.toFixed(2)}%
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="text-right">
                    <p
                      className={`font-semibold ${step.isCumulative ? 'text-lg text-primary' : ''}`}
                    >
                      {currencySymbol} {formatCurrency(displayAmount).replace(/[^\d,.-]/g, '')}
                    </p>
                  </div>
                </div>
                {index < steps.length - 1 && !step.isCumulative && (
                  <div className="flex justify-center py-1">
                    <ArrowDown className="w-4 h-4 text-muted-foreground" />
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Summary */}
        <div className="mt-6 pt-6 border-t">
          <div className="flex items-center justify-between text-lg font-bold">
            <span>Total Final:</span>
            <span className="text-primary">
              {currencySymbol} {formatCurrency(cumulative).replace(/[^\d,.-]/g, '')}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default CostWaterfall;
